export const SYMBOL_LOCALE = Symbol('fitx-locale');

export const getCurrentLocaleReqHeader = () => {
  return (window as any)[SYMBOL_LOCALE];
};

export const setCurrentLocaleReqHeader = (lang: string) => {
  (window as any)[SYMBOL_LOCALE] = lang;
};
